// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".paper-name[data-v-657e7a16] {\n  width: 180px;\n}\n.paper-name-caption[data-v-657e7a16] {\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  white-space: pre-line;\n}\n", ""]);
// Exports
module.exports = exports;
